import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../../../colorVars';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';
import { HoverBox } from '../../../hoverBox/HoverBox';

export const EmaIntersectsFirstCandleLine = ({
  mas,
  priceToBreak,
  priceToBreakLong,
  priceToBreakShort,
  candleDuration,
  size,
  scaleY,
  portalRef,
}) => {
  const breakPriceJson = {
    Category: 'Setup Filter',
    Type: 'EMA Intersect',
    'Break Price': ApplyRounding(priceToBreak, 2),
    'Candle Duration': candleDuration,
  };
  let bothDirections;
  if (priceToBreakLong > 0) bothDirections = true;
  else bothDirections = false;

  return (
    <>
      {scaleY ? (
        <>
          {bothDirections ? (
            <>
              <line
                stroke={colors.blue}
                strokeWidth={2}
                x1={0}
                x2={size}
                y1={scaleY(Number(priceToBreakLong))}
                y2={scaleY(Number(priceToBreakLong))}
              ></line>
              <HoverBox
                json={breakPriceJson}
                topBoundary={scaleY(Number(priceToBreakLong)) - 2}
                bottomBoundary={scaleY(Number(priceToBreakLong)) + 2}
                leftBoundary={0}
                rightBoundary={size}
                portalRef={portalRef}
                size={size}
              />
              <line
                stroke={colors.blue}
                strokeWidth={2}
                x1={0}
                x2={size}
                y1={scaleY(Number(priceToBreakShort))}
                y2={scaleY(Number(priceToBreakShort))}
              ></line>
              <HoverBox
                json={breakPriceJson}
                topBoundary={scaleY(Number(priceToBreakShort)) - 2}
                bottomBoundary={scaleY(Number(priceToBreakShort)) + 2}
                leftBoundary={0}
                rightBoundary={size}
                portalRef={portalRef}
                size={size}
              />
            </>
          ) : (
            <>
              <line
                stroke={colors.blue}
                strokeWidth={2}
                x1={0}
                x2={size}
                y1={scaleY(Number(priceToBreak))}
                y2={scaleY(Number(priceToBreak))}
              ></line>
              <HoverBox
                json={breakPriceJson}
                topBoundary={scaleY(Number(priceToBreak)) - 2}
                bottomBoundary={scaleY(Number(priceToBreak)) + 2}
                leftBoundary={0}
                rightBoundary={size}
                portalRef={portalRef}
                size={size}
              />
            </>
          )}
          {mas.map((ma) => {
            const json = {
              Category: 'Setup Filter',
              Type: 'EMA Intersect',
              'MA Price': ApplyRounding(ma.price, 2),
              'Period Length': ma.periodLength,
            };
            return (
              <g key={ma.maId}>
                <line
                  stroke={colors.yellow}
                  strokeWidth={2}
                  x1={0}
                  x2={size}
                  y1={scaleY(Number(ma.price))}
                  y2={scaleY(Number(ma.price))}
                ></line>
                <HoverBox
                  json={json}
                  topBoundary={scaleY(Number(ma.price)) - 2}
                  bottomBoundary={scaleY(Number(ma.price)) + 2}
                  leftBoundary={0}
                  rightBoundary={size}
                  portalRef={portalRef}
                  size={size}
                />
              </g>
            );
          })}
        </>
      ) : null}
    </>
  );
};

EmaIntersectsFirstCandleLine.propTypes = {
  mas: PropTypes.array,
  priceToBreak: PropTypes.number,
  priceToBreakLong: PropTypes.number,
  priceToBreakShort: PropTypes.number,
  candleDuration: PropTypes.any,
  scaleY: PropTypes.func,
  size: PropTypes.any,
  portalRef: PropTypes.object,
};
